/* eslint-disable no-unused-vars */
import '@fortawesome/fontawesome-free/css/all.min.css';
import { MuiThemeProvider, StylesProvider } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import getConfig from 'next/config';
// import * as Sentry from '@sentry/nextjs';
import Theme from 'components/layout/Theme';
import { VoucherDetailPopupProvider } from 'components-v3/organisms/VoucherDetailPopup';
import { MOBILE } from 'constants/Device';
import { ACCOUNT, CART_URL, CHECKOUT_URL, QUICK_ORDER } from 'constants/Paths';
import {
  AuthProvider,
  CartContextProvider,
  LoadingRoute,
  NotiContextProvider,
  ProductContextProvider,
  SearchProvider,
  SettingProvider,
  TicketProvider,
  WishListProvider,
} from 'context';
import ContextProviderComposer from 'context/ContextProviderComposer';
import App from 'next/app';
import Head from 'next/head';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
// import '../scripts/wydr';
// Toast
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// Theme
import { ThemeProvider as StyledTheme } from 'styled-components';
import { ENV, INSIDER_ID, SHIELD_SITE_ID, WEB_HOST } from 'sysconfig';
import { ScrollToTop, gtag } from 'utils';
// CSS global
// import IconChat from 'components-v2/atoms/IconChat';
import {
  DEFAULT_THUOCSI_DESCRIPTION,
  DEFAULT_THUOCSI_LONG_TITLE,
  DEFAULT_THUOCSI_TITLE,
} from 'constants/data';
import Cookies from 'js-cookie';
import { appWithTranslation, i18n as i18nInstance } from 'next-i18next';
import Script from 'next/script';
// import * as Services from 'services';
import { postShieldAttributes } from 'clients/ShieldClient';
import SupportCenter from 'components-v2/organisms/SupportCenter';
import { VISITED_URLS_STORAGE_KEY } from 'constants/data/cookies';
import Clarity from 'third-party/Clarity';
import fbpixel from 'utils/fbpixel';
import { GA_TRACKING_ID_V2 } from 'utils/gtag';
import { captureUtmLandingURL } from 'utils/registerURL';
import { GLOBAL_STORE } from 'zustand-lib';
import useMobileV2 from 'zustand-lib/storeMobile';
import useChat from 'zustand-lib/useChat';
import nextI18nConfig from '../../next-i18next.config';
import '../styles/globals.css';
import '../styles/icomoon.css';

// Happy lunar new year 2023
// const IconChat = dynamic(() => import('components-v2/atoms/IconChat'), { ssr: false });
// const ChatThuocSi = dynamic(() => import('utils/ChatThuocsi'), { ssr: false });

const { publicRuntimeConfig } = getConfig();

// const pathNoRedirect = [
//   '/',
//   '/list-product',
//   '',
//   '/flagship-store',
//   '/flagship-store/[slug]/list-product',
//   '/flagship-store/[slug]',
//   '/flagship-store/durex',
//   '/flagship-store/durex/list-product',
//   '/flagship-store/durex/rewards',
//   '/flagship-store/sanofi',
//   '/flagship-store/sanofi/list-product',
//   '/flagship-store/sanofi/rewards',
//   '/phanhoi',
//   '/qr',
//   '/qr/[code]',
//   'phanhoi',
//   'feedback',
//   '/feedback',
//   '/flagship-store/[slug]/flagship-rewards',
//   '/flagship-store/[slug]/rewards',
//   '/tracking-order',
// ];
const PLATFORM = 'WEB';
// const DOMAIN = 'buymed.com.kh';

const DISABLE_INSIDER = ['tracuu.thuocsi.vn', 'phanhoi.thuocsi.vn'];
const CHAT_HIDE_URLS = ['/discovery', CART_URL, CHECKOUT_URL, ACCOUNT, QUICK_ORDER];

const MyApp = (props) => {
  const { Component, pageProps, host = '', buildId = '' } = props;

  const {
    user = {},
    accountInfo = {},
    SEO_CONFIG = {},
    initialZustandState = {},
  } = pageProps || {};

  const { useCreateStore, Provider } = GLOBAL_STORE || {};

  // Sentry?.setTag('buildId', buildId);
  // Sentry.setUser({ id: user?.customerID });
  const {
    insiderSetting = false,
    thumbnailMap = {},
    defaultThumbnail = {},
    regionsMB = [],
    CONVERT_USD_TO_KHR,
  } = initialZustandState || {};

  useEffect(() => {
    if (window) window.CONVERT_USD_TO_KHR = CONVERT_USD_TO_KHR;
  }, []);

  const router = useRouter();
  const { query, replace, pathname } = router || {};
  const createStore = useCreateStore(pageProps.initialZustandState);
  const { referCode, action, login, forgetpasscode, t, token, redirectUrl } = query || {};
  const isShowingLogin = login === 'true';
  const isMobileV2 = useMobileV2((state) => state.isMobileV2());
  const isTrackingMobileV2 = useMobileV2((state) => state.isTrackingMobileV2);

  const { clearState } = useChat((state) => state);
  let isEnableInsider = insiderSetting;
  if (host) {
    isEnableInsider = !DISABLE_INSIDER.some((item) => item === host) && insiderSetting;
  }

  // Dùng SEO default là thông tin SEO của trang chủ
  const seoInfo = thumbnailMap[router.asPath] || {};
  const toggleChat = () => {
    clearState();
    router.push(`/conversations`);
  };

  // hide page chat
  const isShowIconFBPage = !CHAT_HIDE_URLS.includes(pathname);

  // config https://material-ui.com/guides/server-rendering/
  useEffect(() => {
    const jssStyles = document.querySelector('#jss-server-side');
    if (jssStyles) {
      jssStyles.parentElement.removeChild(jssStyles);
    }

    // Prevent pull to refresh for chat mobile
    if (router.pathname === '/conversations') {
      document.querySelector('html')?.classList.add('preventPullToRefresh');
    } else {
      document.querySelector('html')?.classList?.remove('preventPullToRefresh');
    }
  }, []);

  const saveUrlWhenChangeRoute = () => {
    try {
      const visitedUrls = JSON.parse(localStorage.getItem(VISITED_URLS_STORAGE_KEY) || '[]');

      const currentUrl = window?.location?.href;
      if (currentUrl && currentUrl?.startsWith('http')) {
        let newVisitedUrls = currentUrl;

        if (visitedUrls[visitedUrls.length - 1] !== currentUrl) {
          newVisitedUrls = [...visitedUrls, currentUrl];
        }

        if (newVisitedUrls.length > 5) {
          // Chỉ lấy 5 urls gần nhất
          newVisitedUrls = newVisitedUrls.slice(newVisitedUrls.length - 5, newVisitedUrls.length);
        }

        localStorage.setItem(VISITED_URLS_STORAGE_KEY, JSON.stringify(newVisitedUrls));
      }
    } catch (e) {
      localStorage.setItem(VISITED_URLS_STORAGE_KEY, '[]');
    }
  };

  useEffect(() => {
    const handleRouteChange = async (url) => {
      fbpixel.pageview();
      gtag.pageview(url, user);
      // save router change
      saveUrlWhenChangeRoute();
      // fbpixel.pageview();
    };
    router.events.on('routeChangeComplete', handleRouteChange);
    return () => {
      router.events.off('routeChangeComplete', handleRouteChange);
    };
  }, [router.events]);

  // BV-1681: every page follows the language the user chose (NEXT_LOCALE cookie, set by the guest header switch
  // and ToggleProfile). SSR pages get it from the server, but on static pages (getStaticProps) and on client-side
  // navigation to a page without `_nextI18Next`, appWithTranslation switches to the default locale (`cam`).
  // Re-apply the cookie language whenever a language change starts or ends with another target. Compare with the
  // language being switched to (a change is async while its namespaces load), and check after the current call
  // stack so a switcher that sets the cookie right after changeLanguage is not reverted.
  useEffect(() => {
    const i18n = i18nInstance;
    if (!i18n) return undefined;
    const applyCookieLanguage = () => {
      const cookieLang = Cookies.get('NEXT_LOCALE');
      const targetLang = i18n.isLanguageChangingTo || i18n.language;
      if (
        cookieLang &&
        cookieLang !== targetLang &&
        nextI18nConfig.i18n.locales.includes(cookieLang)
      ) {
        i18n.changeLanguage(cookieLang);
      }
    };
    const scheduleApply = () => Promise.resolve().then(applyCookieLanguage);
    applyCookieLanguage();
    i18n.on('languageChanging', scheduleApply);
    i18n.on('languageChanged', scheduleApply);
    return () => {
      i18n.off('languageChanging', scheduleApply);
      i18n.off('languageChanged', scheduleApply);
    };
  }, []);

  // BV-1681: remember the last UTM landing URL (sessionStorage) for registerURL at sign-up
  useEffect(() => {
    const handleCaptureUtm = () => captureUtmLandingURL();
    handleCaptureUtm();
    router.events.on('routeChangeComplete', handleCaptureUtm);
    return () => {
      router.events.off('routeChangeComplete', handleCaptureUtm);
    };
  }, [router.events]);

  useEffect(() => {
    // SHIELD_SITE_ID
    if (!SHIELD_SITE_ID || !user) {
      return () => {};
    }

    // const { name, customerID } = user || {};
    const { customerID } = user || {};
    const { pathname: pathNameWindow } = window.location;
    const baseUrl = pathNameWindow;
    const { rootAccountID } = user?.session || { rootAccountID: '' };

    const callBackFunc = async () => {
      window.getDeviceResult().then(
        async (res) => {
          // const deviceIntelligence = res.result?.device_intelligence;
          const sessionId = res.result?.session_id;
          const cloneResult = JSON.parse(JSON.stringify(res.result));
          if (cloneResult.timestamp === 0) {
            delete cloneResult.timestamp;
          }
          delete cloneResult.device_intelligence;

          // postShieldResult({
          //   deviceIntelligence,
          //   others: {
          //     ...cloneResult,
          //   },
          //   error: null,
          //   userInfo: {
          //     id: customerID?.toString(),
          //     name,
          //     rootAccountID: rootAccountID ? rootAccountID?.toString() : undefined,
          //   },
          //   screen: pathname,
          //   platform: PLATFORM,
          //   action: 'SUCCESS',
          //   appName: DOMAIN,
          //   fullURI: baseUrl,
          // })
          if (user) {
            // sendAttributes({ ...user, baseUrl, sessionId, rootAccountID });
            try {
              postShieldAttributes({
                platform: PLATFORM,
                env: ENV === 'prd' || ENV === 'uat' ? 'prd' : 'stg',
                userId: customerID?.toString() || undefined,
                email: user?.email || '',
                mobileNumber: user?.phone || '',
                fullUri: baseUrl,
                sessionId,
                rootAccountID: rootAccountID ? rootAccountID?.toString() : undefined,
              });
            } catch (error) {
              console.error('Failed to send:', error);
            }
          }
        },
        // async (error) => {
        // postShieldResult({
        //   deviceIntelligence: {},
        //   others: {},
        //   error,
        //   userInfo: {},
        //   screen: pathname,
        //   platform: PLATFORM,
        //   action: 'FAILURE',
        //   appName: DOMAIN,
        //   fullURI: baseUrl,
        // })
        // },
      );
    };
    // Load script
    const script = document.createElement('script');
    script.src = `https://d1cr9zxt7u0sgu.cloudfront.net/shdfp.js?SITE_ID=${SHIELD_SITE_ID}&TYPE=JS&DE=1&AUTO=0`;
    script.async = true;
    script.charset = 'UTF-8';
    script.onload = callBackFunc; // Call your function when script is loaded

    document.body.appendChild(script);

    // Cleanup
    return () => {
      document.body.removeChild(script);
    };
  }, [user?.customerID]);

  const LinkBanner = `${WEB_HOST}/logo_banner.png`;
  // SEO: canonical = URL hiện tại bỏ query string, để ?utm=..., ?page=... không bị Google coi là bản trùng
  const canonicalUrl = WEB_HOST + (router?.asPath || '/').split(/[?#]/)[0];
  return (
    <>
      <Head>
        <meta charSet="utf-8" />
        <meta httpEquiv="Cache-Control" content="no-cache" />
        <meta httpEquiv="Expires" content="-1" />
        <meta name="keywords" content="buymed" />
        <title>
          {seoInfo?.pageTitle ||
            SEO_CONFIG?.title ||
            defaultThumbnail?.pageTitle ||
            DEFAULT_THUOCSI_LONG_TITLE}
        </title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, user-scalable=no"
        />
        <link rel="canonical" href={canonicalUrl} />
        <link rel="manifest" href="/manifest.json" />

        <meta
          property="title"
          content={
            seoInfo?.title || SEO_CONFIG?.title || defaultThumbnail?.title || DEFAULT_THUOCSI_TITLE
          }
        />
        <meta
          property="description"
          content={
            seoInfo?.description ||
            SEO_CONFIG?.description ||
            defaultThumbnail?.description ||
            DEFAULT_THUOCSI_DESCRIPTION
          }
        />
        <meta
          property="og:title"
          content={
            seoInfo?.title ||
            SEO_CONFIG?.ogTitle ||
            defaultThumbnail?.title ||
            DEFAULT_THUOCSI_TITLE
          }
        />
        <meta
          property="og:image"
          content={
            seoInfo?.imageUrl || SEO_CONFIG?.ogImage || defaultThumbnail?.imageUrl || LinkBanner
          }
        />
        <meta
          property="og:image:alt"
          content={
            seoInfo?.title ||
            SEO_CONFIG?.ogImageAlt ||
            defaultThumbnail?.title ||
            DEFAULT_THUOCSI_LONG_TITLE
          }
        />
        <meta
          property="og:description"
          content={
            seoInfo?.description ||
            SEO_CONFIG?.ogDescription ||
            defaultThumbnail?.description ||
            DEFAULT_THUOCSI_DESCRIPTION
          }
        />

        {/* Shield JavaScript and NoScript */}
        {SHIELD_SITE_ID && (
          <>
            <noscript>
              <iframe
                src={`https://${SHIELD_SITE_ID}.csftr.com/shield-fp/v1/api/web/noscript?site_id=${SHIELD_SITE_ID}`}
                width="0"
                height="0"
                style={{ display: 'none' }}
                title="Shield NoScript"
              />
            </noscript>
          </>
        )}
      </Head>
      {/* <NextNprogress color="#29D" startPosition={0.3} stopDelayMs={200} height="3" options={{ showSpinner: false }} /> */}
      <StylesProvider injectFirst>
        <StyledTheme theme={Theme}>
          <MuiThemeProvider theme={Theme}>
            <CssBaseline />
            {/* Context composer */}
            <Provider createStore={createStore}>
              <ContextProviderComposer
                contextProviders={[
                  <AuthProvider
                    key="auth"
                    isShowingLogin={isShowingLogin}
                    referCode={referCode}
                    forgetpasscode={forgetpasscode}
                    action={action}
                    tokenv1={t}
                    token={token}
                    redirectUrl={redirectUrl}
                    // initAccount={accountInfo}
                    initUser={user}
                  />,
                  <ProductContextProvider key="product" initUser={user} />,
                  <CartContextProvider key="cart" />,
                  <NotiContextProvider key="noti" />,
                  <SettingProvider key="setting" />,
                  <SearchProvider key="search" />,
                  <WishListProvider key="wishlist" />,
                  <TicketProvider key="ticket" />,
                  // <Provider config={rollbarConfig} />,
                ]}
              >
                {/* Protect route */}
                <LoadingRoute>
                  <Clarity />
                  {/* popup chi tiết voucher dùng chung (/promo-codes, giỏ, trang SP); cần Auth + Cart */}
                  <VoucherDetailPopupProvider isMobile={!!pageProps?.isMobile}>
                    <Component {...pageProps} />
                  </VoucherDetailPopupProvider>
                  {/* TODO: FbMessenger  FEATURE-CHAT */}
                  {/* {pageProps.isMobile && isShowIconFBPage && pageProps?.isAuthenticated && <IconChat isAuthenticated={pageProps?.isAuthenticated} onClick={toggleChat} />} */}
                  {pathname !== '/conversations' && pathname !== '/lucky-wheel' && (
                    <SupportCenter
                      isMobile={pageProps.isMobile}
                      isShowIconFBPage={isShowIconFBPage}
                      isAuthenticated={pageProps?.isAuthenticated}
                      toggleChat={toggleChat}
                    />
                  )}
                  {/* {pageProps.isMobile && isShowIconFBPage && <IconChat isAuthenticated={pageProps?.isAuthenticated} onClick={toggleChat} />} */}
                  {/* ChatThuocSi comp gồm FB mess, Internal Chat, Chat setting */}
                  {/* add key để reload lại chat khi login */}
                  {/* {!pageProps.isMobile && <ChatThuocSi key={pageProps?.isAuthenticated || null} />} */}
                  {pathname !== '/conversations' && <ScrollToTop {...router} />}
                  {/* {!pageProps.isMobile && <ContactInfoFixed />} */}
                  <ToastContainer
                    limit={2}
                    pauseOnHover={false}
                    hideProgressBar
                    autoClose={2000}
                    closeOnClick
                  />
                </LoadingRoute>
              </ContextProviderComposer>
            </Provider>
          </MuiThemeProvider>
        </StyledTheme>
      </StylesProvider>
      {isEnableInsider && INSIDER_ID && (
        <Script
          id={INSIDER_ID}
          src={`https://thuocsivn.api.useinsider.com/ins.js?id=${INSIDER_ID}`}
          strategy="afterInteractive"
        />
      )}

      {ENV === 'prd' && isMobileV2 && isTrackingMobileV2 && (
        <>
          <Script
            strategy="lazyOnload"
            src={`https://www.googletagmanager.com/gtag/js?id=${GA_TRACKING_ID_V2}&l=dataLayerGAV2`}
          />
          <Script strategy="lazyOnload">
            {`
                    window.dataLayerGAV2 = window.dataLayerGAV2 || [];
                    function gtagGAV2(){dataLayerGAV2.push(arguments);}
                    gtagGAV2('js', new Date());
                    gtagGAV2('config', '${GA_TRACKING_ID_V2}', {
                    page_path: window.location.pathname,
                    });
                `}
          </Script>
        </>
      )}
    </>
  );
};

MyApp.propTypes = {
  Component: PropTypes.elementType.isRequired,
  pageProps: PropTypes.object.isRequired,
};

// MyApp.getInitialProps = async (appContext) => ({ ...(await App.getInitialProps(appContext)) });

MyApp.getInitialProps = async (appContext) => {
  const time = +new Date();
  const appProps = await App.getInitialProps(appContext);
  let host = '';
  try {
    host = appContext.ctx.req.headers.host || '';
  } catch (error) {
    host = "can't detect host";
  }

  let isMobile = '';
  try {
    const UA = appContext.ctx.req.headers['user-agent'];
    isMobile = Boolean(UA.match(MOBILE));
  } catch (error) {
    isMobile = `can not detect device - ${error}`;
  }

  return {
    ...appProps,
    host,
    buildId: publicRuntimeConfig.buildId,
    timeAPP: +new Date() - time,
    pageProps: {
      isMobile,
    },
  };
};

export default appWithTranslation(MyApp, nextI18nConfig);
